var React = require('react');

function Bracket (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.192 61.784V73.304H35.296C31.072 73.304 28.96 75.704 28.96 80.504V113.624C28.96 120.632 27.088 125.912 23.344 129.464C19.696 133.112 14.272 134.936 7.07199 134.936H0.735992V123.56H4.19199C11.488 123.56 15.136 119.816 15.136 112.328V80.792C15.136 76.76 15.712 73.784 16.864 71.864C18.112 69.848 20.128 68.408 22.912 67.544C20.128 66.68 18.112 65.288 16.864 63.368C15.712 61.352 15.136 58.328 15.136 54.296V22.76C15.136 15.272 11.488 11.528 4.19199 11.528H0.735992V0.151978H7.07199C14.272 0.151978 19.696 1.97598 23.344 5.62398C27.088 9.17598 28.96 14.456 28.96 21.464V54.584C28.96 59.384 31.072 61.784 35.296 61.784H40.192Z","fill":"#D62F0B"}));
}

Bracket.defaultProps = {"width":"41","height":"135","viewBox":"0 0 41 135","fill":"none"};

module.exports = Bracket;

Bracket.default = Bracket;
